import styled from 'styled-components';
import { AccordionHeader, AccordionBody, UncontrolledAccordion, Badge } from 'reactstrap';

export const AccordionTitle = styled(AccordionHeader)`
  background-color: #fff;
  border-radius: 5px;
  button {
    font-weight: 500;
    font-size: 1rem;
  }
  button:not(.collapsed) {
    background-color: #fff;
    color: #000;
  }
  button:not(.collapsed)::after {
    filter: grayscale(100%);
  }
`;

export const AccordionTable = styled(AccordionBody)`
  background-color: #fff !important;
`;

export const LoadingAccordions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

export const AccordionNameRow = styled.button`
  color: #495057;
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;

export const UncontrolledAccordionStyled = styled(UncontrolledAccordion)`
  .accordion-item {
    border-width: 0 !important;
  }
  .accordion-button {
    box-shadow: none !important;
    padding: 1.5rem;
  }
`;

export const BadgeTypeStyled = styled(Badge)`
  display: flex;
  height: 1.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  color: #fff;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  background-color: ${({ $type }) => {
    switch ($type) {
      case 'PRODUCTION':
        return '#f2994a !important';
      case 'PRODUCTION_AND_UNIFICATION':
        return '#f2c94c !important';
      case 'REVIEW':
        return '#2d9cdb !important';
      case 'REVIEW_AND_DIRECTIONS':
        return '#bb6bd9 !important';
      default:
        return '#6c757d !important';
    }
  }};
`;

export const BadgeNumberStyled = styled(Badge)`
  display: flex;
  height: 1.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  background-color: #f8f8fb !important;
  max-width: max-content;
  color: #343a40;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  vertical-align: middle;
`;

export const TableWrapper = styled.div`
  .table {
    background-color: #fff !important;
  }

  .table thead th {
    background-color: #f8f9fa !important;
    color: #333;
  }

  .table tbody tr {
    background-color: #fff !important;
  }

  .table tbody tr td {
    background-color: #fff !important;
    overflow: visible;

    p {
      margin: 0 !important;
      vertical-align: middle;
    }

    .dropdown .btn-menu {
      background-color: transparent !important;
      border: 1px solid #e2e8f0 !important;
      height: 2.25rem;

      i {
        color: rgba(72, 72, 72, 1);
      }
      &:hover {
        background-color: #f1f1f1 !important;
      }
    }
  }

  .table tbody tr td:nth-child(2) {
    cursor: pointer;
  }

  .table tbody tr td:nth-child(3) {
    vertical-align: text-top;
  }

  .table tbody tr td:last-child {
    vertical-align: text-top;
    text-align: center;
  }
`;
